var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.542,
    height: 22,
    viewBox: "0 0 20.542 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1274 498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.941,264.079a1,1,0,0,0-1,1,4.069,4.069,0,1,1-4.069-4.068c.11,0,.218.012.327.021l-1.336.934a1,1,0,1,0,1.146,1.639l3.035-2.123a1,1,0,0,0,.246-1.392l-2.123-3.035a1,1,0,1,0-1.638,1.147l.576.824c-.078,0-.155-.015-.233-.015a6.069,6.069,0,1,0,6.069,6.068A1,1,0,0,0,276.941,264.079Z",
    transform: "translate(-1531.398 -754.629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.906,273.094a1.015,1.015,0,0,0-.986,1.04v3.377a1.015,1.015,0,0,1-.986,1.04H259.179a1.015,1.015,0,0,1-.986-1.04v-12.9a1.015,1.015,0,0,1,.986-1.04h4.274a1.042,1.042,0,0,0,0-2.08h-4.274a3.046,3.046,0,0,0-2.959,3.121v12.9a3.046,3.046,0,0,0,2.959,3.121h11.754a3.046,3.046,0,0,0,2.959-3.121v-3.377A1.015,1.015,0,0,0,272.906,273.094Z",
    transform: "translate(-1530.22 -756.631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.428,274.045a1,1,0,0,0,1,1h6.9a1,1,0,0,0,0-2h-6.9A1,1,0,0,0,260.428,274.045Z",
    transform: "translate(-1530.607 -755.603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.429,270.148a1,1,0,0,0,1,1h3.226a1,1,0,0,0,0-2h-3.226A1,1,0,0,0,260.429,270.148Z",
    transform: "translate(-1530.521 -755.372)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.d31afde1.svg";
export { ForwardRef as ReactComponent };